import {styled} from "@mui/material/styles"

type Props = {
    alignTop?: boolean
}

export const Anchor = styled("a", {
    shouldForwardProp: prop => prop !== "alignTop",
})`
    color: inherit;
    font-size: 12px;
    text-decoration: none;
    text-transform: capitalize;
    display: flex;
    align-items: ${({alignTop}: Props) => (alignTop ? "start" : "center")};
    letter-spacing: 0.0075rem;
    &:hover {
        text-decoration: underline;
    }
`
